import getRandomValues from 'polyfill-crypto.getrandomvalues';

if (typeof window.crypto === 'undefined') {
    window.crypto = { getRandomValues };
}
